<app-auth-shell [testimonial]="false">
  @switch (errorKind()) {
    @case ('account_disabled') {
      <app-auth-header
        [title]="'kratosMessages.errors.account_disabled.header' | transloco"
        [subtitle]="
          'kratosMessages.errors.account_disabled.subheader' | transloco
        " />
      <app-auth-panel>
        <p class="text-sm tracking-tight text-zinc-300">
          {{ 'kratosMessages.errors.account_disabled.message' | transloco }}
        </p>
        <vx-button size="lg" [fullWidth]="true" (click)="openContactDetails()">
          {{ 'misc.contactSupportBtn' | transloco }}
        </vx-button>
      </app-auth-panel>
    }
    @case ('sign_in_interrupted') {
      <app-auth-header
        [title]="'kratosMessages.errors.sign_in_interrupted.header' | transloco"
        [subtitle]="
          'kratosMessages.errors.sign_in_interrupted.subheader' | transloco
        " />
      <app-auth-panel>
        <p class="text-sm tracking-tight text-zinc-300">
          {{ 'kratosMessages.errors.sign_in_interrupted.message' | transloco }}
        </p>
        <vx-button size="lg" [fullWidth]="true" (click)="restartSignIn()">
          {{ 'kratosMessages.errors.restartSignInBtn' | transloco }}
        </vx-button>
      </app-auth-panel>
      <app-auth-help />
    }
    @case ('generic') {
      <app-auth-header
        [title]="'kratosMessages.errors.generic.header' | transloco"
        [subtitle]="'kratosMessages.errors.generic.subheader' | transloco" />
      <app-auth-panel>
        <p class="text-sm tracking-tight text-zinc-300">
          {{ 'kratosMessages.errors.generic.message' | transloco }}
        </p>
        <vx-button size="lg" [fullWidth]="true" (click)="restartSignIn()">
          {{ 'kratosMessages.errors.restartSignInBtn' | transloco }}
        </vx-button>
      </app-auth-panel>
      <app-auth-help />
    }
    @default {
      <vx-skeleton class="h-6 w-6 rounded-md" />
      <vx-skeleton class="mt-5 h-6.5 w-56" />
      <vx-skeleton class="mt-2 h-4 w-72" />
      <vx-skeleton class="mt-8 h-36 w-full rounded-2xl" />
    }
  }
</app-auth-shell>
